import { render, staticRenderFns } from "./ArmsBaseArchiveCatalog.vue?vue&type=template&id=5ef0aad8&scoped=true&"
import script from "./ArmsBaseArchiveCatalog.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseArchiveCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0aad8",
  null
  
)

export default component.exports